import React from 'react'
import LogPage from '../../components_renew/common/LogPage'

const CardGameLog = () => {
  return <LogPage title={'中奖记录'} api={window.API.CardGame.getLotteryLog}>
  </LogPage>
}

export default CardGameLog
